import React from "react";
import { toast } from "react-toastify";
import { deleteWarehouse } from "../../../apis/apis.logistics/apisProduct";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableHeader,
    Badge,
} from "../../../components/ui";

const thClass =
    "px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400";

export function WarehouseList({
    warehouses,
    setWarehouses,
    onOpenWarehouseModal,
    emptyWarehouse,
}) {
    function removeWarehouseInGrid(item) {
        return warehouses.filter(
            (warehouse) => warehouse.warehouseID != item.warehouseID
        );
    }

    const restRemoveWarehouse = async (registerData) => {
        try {
            const response = await deleteWarehouse(registerData);
            return response;
        } catch (error) {
            throw error;
        }
    };

    function handleBtnRemove(item) {
        if (window.confirm("¿Estás seguro de que deseas eliminar este almacén?")) {
            if (item.productDict.length) {
                toast.error("El almacén aún contiene productos.");
            } else {
                restRemoveWarehouse(item).then(async (r) => {
                    if (r.status == 201 && r.success) {
                        await setWarehouses(removeWarehouseInGrid(item));
                        toast.success("Almacén eliminado con éxito!");
                    } else {
                        toast.error("Ocurrió algún error");
                    }
                });
            }
        }
    }

    return (
        <div className="space-y-4">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <button
                    type="button"
                    onClick={() => onOpenWarehouseModal(emptyWarehouse)}
                    className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-blue-700"
                >
                    <i className="fas fa-plus" aria-hidden="true" />
                    Agregar Nuevo Almacén
                </button>
                <Badge variant="primary" className="w-fit px-3 py-1">
                    <i className="fas fa-warehouse mr-1" aria-hidden="true" />
                    {warehouses.length}{" "}
                    {warehouses.length === 1 ? "almacén" : "almacenes"}
                </Badge>
            </div>

            <div className="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
                <Table className="min-w-[640px] text-sm">
                    <TableHead>
                        <tr>
                            <TableHeader className={`${thClass} w-24 text-center`}>
                                Código
                            </TableHeader>
                            <TableHeader className={thClass}>Nombre</TableHeader>
                            <TableHeader className={`${thClass} w-36`}>Tipo</TableHeader>
                            <TableHeader className={`${thClass} w-36`}>Sede</TableHeader>
                            <TableHeader
                                align="center"
                                className={`${thClass} w-40`}
                            >
                                Acciones
                            </TableHeader>
                        </tr>
                    </TableHead>
                    <TableBody>
                        {warehouses.length > 0 ? (
                            warehouses.map((item, index) => (
                                <TableRow key={index} hover>
                                    <TableCell align="center">
                                        <span className="inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                                            {item.warehouseID}
                                        </span>
                                    </TableCell>
                                    <TableCell className="font-medium">
                                        {item.warehouseName}
                                    </TableCell>
                                    <TableCell>{item.warehouseCategoryDisplay}</TableCell>
                                    <TableCell>{item.subsidiaryName}</TableCell>
                                    <TableCell align="center">
                                        <div className="flex flex-wrap items-center justify-center gap-2">
                                            <button
                                                type="button"
                                                onClick={() => onOpenWarehouseModal(item)}
                                                className="inline-flex items-center rounded-lg border border-blue-600 px-3 py-1 text-sm font-semibold text-blue-600 transition-colors hover:bg-blue-50 dark:border-blue-400 dark:text-blue-400 dark:hover:bg-blue-900/30"
                                            >
                                                <i
                                                    className="fas fa-edit mr-1"
                                                    aria-hidden="true"
                                                />
                                                Editar
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => handleBtnRemove(item)}
                                                className="inline-flex items-center rounded-lg border border-red-600 px-3 py-1 text-sm font-semibold text-red-600 transition-colors hover:bg-red-50 dark:border-red-400 dark:text-red-400 dark:hover:bg-red-900/30"
                                            >
                                                <i
                                                    className="fas fa-trash mr-1"
                                                    aria-hidden="true"
                                                />
                                                Eliminar
                                            </button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell
                                    colSpan={5}
                                    align="center"
                                    className="py-10 text-gray-500 dark:text-gray-400"
                                >
                                    <i
                                        className="fas fa-warehouse mb-2 text-3xl"
                                        aria-hidden="true"
                                    />
                                    <p className="mb-1 font-medium">
                                        No hay almacenes registrados
                                    </p>
                                    <p className="text-xs">
                                        Haga clic en &quot;Agregar Nuevo Almacén&quot; para
                                        comenzar
                                    </p>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
